import { BoardID } from 'BoardID';
import { BoardHash, RouteParams } from 'Types';
import useReactRouter from 'use-react-router';

export default function useRouter() {
  const reactRouter = useReactRouter<RouteParams>();

  function getSearch() {
    return window.location.search ?? '';
  }

  return {
    navToBoardID(boardID: BoardID) {
      reactRouter.history.push(`/designer/id/${boardID}${getSearch()}`);
    },

    navToBoardHash(boardHash: BoardHash) {
      reactRouter.history.push(`/designer/hash/${boardHash}${getSearch()}`);
    },

    navToInstructionsForID(boardID: BoardID) {
      reactRouter.history.push(`/build_steps/id/${boardID}${getSearch()}`);
    },

    navToInstructionsForHash(boardHash: BoardHash) {
      reactRouter.history.push(`/build_steps/hash/${boardHash}${getSearch()}`);
    },
  };
}
